import { ChainIdLegacy } from "@silo/types";

export const adjustChainId = (chainId: ChainIdLegacy): ChainIdLegacy => {
  switch (chainId) {
    case ChainIdLegacy.LOCAL:
    case ChainIdLegacy.ANVIL:
      return ChainIdLegacy.MAINNET;
    default:
      return chainId;
  }
};
